/**
 * Created by lei.sun on 2017/9/17.
 */

import * as types from './mutations-types';
import * as modules from './modules/index';
import actions from './actions';

const state = {

};

// getters
const getters = {

};

// mutations
const mutations = {

};

export {
  state
};

export default {
  state,
  getters,
  actions,
  mutations,
  modules
}


// WEBPACK FOOTER //
// ./src/store/Common/index.js